import React from 'react';
import { Route } from 'react-router-dom';

import AssistantsManagerSettings from './AssistantsManagerSettings/AssistantsManagerSettings';
import Assistants from './Assistants/Assistants';
import ConnectSalesAssistant from './ConnectSalesAssistant/ConnectSalesAssistant';
import RecommendationSettings from './RecommendationSettings/RecommendationSettings';
import RuleBuilderEditForm from './RecommendationSettings/RuleBuilder/RuleBuilderEditForm';
import RuleBuilderCreateForm from './RecommendationSettings/RuleBuilder/RuleBuilderCreateForm';
import Notifications from './RecommendationSettings/Notifications';
import ImportSalesforceUsers from './RecommendationSettings/ImportSalesforceUsers';

function AssistantsPage() {
  return (
    <>
      <Route exact path="/assistants/manager/settings" component={AssistantsManagerSettings} />
      <Route exact path="/assistants" component={Assistants} />
      <Route exact path="/assistants/sales/connect" component={ConnectSalesAssistant} />
      <Route exact path="/assistants/sales" component={RecommendationSettings} />
      <Route exact path="/assistants/sales/rule_builder" component={RuleBuilderCreateForm} />
      <Route exact path="/assistants/sales/rule_builder/:id" component={RuleBuilderEditForm} />
      <Route exact path="/assistants/sales/notifications" component={Notifications} />
      <Route exact path="/assistants/sales/import_salesforce_users" component={ImportSalesforceUsers} />
    </>
  );
}

export default AssistantsPage;
